// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"HtmlBox_wrapper__2AR72","checkboxLabel":"HtmlBox_checkboxLabel__1_tRE","codeEditor":"HtmlBox_codeEditor__VjrEl"};